import type { FmMapWorkspaceDescriptor } from './FmMapWorkspaceRoot.types';
import {
  assertMapWorkspaceExactObject as exactObject,
  requireMapWorkspaceText as requireText,
} from './FmMapWorkspaceValidation.shared';

export function validateMapWorkspaceNotice(descriptor: FmMapWorkspaceDescriptor): void {
  if (!descriptor.notice) return;
  exactObject(
    descriptor.notice,
    ['title', 'description', 'actionId', 'actionLabel', 'testId'],
    'notice',
  );
  requireText(descriptor.notice.title, 'notice.title');
  requireText(descriptor.notice.description, 'notice.description');
  requireText(descriptor.notice.actionId, 'notice.actionId');
  requireText(descriptor.notice.actionLabel, 'notice.actionLabel');
  requireText(descriptor.notice.testId, 'notice.testId');
}
